{
  "w": 28,
  "h": 18,
  "rows": [
    "............................",
    "....WWWWWWWWWWWWWWWWWWWW....",
    "..MMCCCCCCCCCCCCCCCCCCCCMM..",
    "MMCCCCCCCCCCCCCCCCCCCCCCCCMM",
    "MMCCCCCCCCCCCCCCCCCCCCCCCCMM",
    "MMCCCCCCCCCCCCCCCCCCCCCCCCMM",
    "MMccccccccccccccccccccccccMM",
    "MMccccccccccccccccccccccccMM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "YYKmmmmmmmmmmmmmmmmmmmmmmKYY",
    "YYKmmmmmmmmmmmmmmmmmmmmmmKYY",
    "YYKmmmmmmmKKKKKKKKmmmmmmmKYY",
    "KKWKKKKKKKKKKKKKKKKKKKKKKWKK",
    "......KKKK........KKKK......",
    "............................"
  ],
  "legend": {
    "K": "C.BLACK",
    "M": "C.B_MAGENTA",
    "m": "C.MAGENTA",
    "C": "C.B_CYAN",
    "c": "C.CYAN",
    "W": "C.B_WHITE",
    "Y": "C.B_YELLOW"
  }
}
